import React from 'react';
import { usePreviewSearchActions } from '@sitecore-search/react';
import { PreviewSearch } from '@sitecore-search/ui';
import PropTypes from 'prop-types';
import GoogleIcon from '../google-icon';
import Loader from '../loader';

function SuggestionBlock({ items, title, blockId, loading, prefixIcon = null, redirectUrl }) {
    const { onSuggestionClick } = usePreviewSearchActions();
    const onSuggestionLinkClick = (e, text) => {
        e.preventDefault();
        onSuggestionClick({
            name: blockId,
            title,
            value: text,
            displayName: text
        });
        window.location.href = `${redirectUrl}?q=${text}`;
    };

    if (items.length === 0 && !loading) {
        return null;
    }

    return (
        <PreviewSearch.SuggestionsGroup className="sitecore-search-suggestions search-suggestions" id={blockId}>
            <h6>{title}</h6>
            <div className="search-suggestions">
                {loading ? <Loader /> : items.length > 0 && items.map(({ text }) => (
                    <PreviewSearch.SuggestionTrigger
                        id={text}
                        key={text}
                        asChild={true}
                    >
                        <a
                            href={`${redirectUrl}?q=${text}`}
                            onClick={e => onSuggestionLinkClick(e, text)}
                        >
                            {prefixIcon && <GoogleIcon icon={prefixIcon} /> }
                            <span>
                                {text}
                            </span>
                        </a>
                    </PreviewSearch.SuggestionTrigger>
                ))}
            </div>
        </PreviewSearch.SuggestionsGroup>
    );
}

SuggestionBlock.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string.isRequired })).isRequired,
    title: PropTypes.string.isRequired,
    blockId: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    redirectUrl: PropTypes.string.isRequired,
    prefixIcon: PropTypes.string
};

export default SuggestionBlock;
